import React, { useEffect, useState } from 'react';
import { Container, Grid, Typography, Box, Button } from '@mui/material';
import { motion } from 'framer-motion';
import getStyles from './styles';
import { useNavigate } from 'react-router-dom';

const OurProjectsClients = () => {
  const styles = getStyles();
  const navigate = useNavigate();
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [scrollY, setScrollY] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth - 0.5) * 2,
        y: (e.clientY / window.innerHeight - 0.5) * 2
      });
    };

    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const portfolioItems = [
    {
      id: 1,
      name: 'StartupTN',
      description: 'Digital platform empowering Tamil Nadu startup ecosystem.',
      image: '/images/startuptn-first.png',
      color: '#0ea5e9',
      gradient: 'linear-gradient(135deg, #0ea5e9 0%, #06b6d4 100%)',
      navigate: '/works/startuptn'
    },
    {
      id: 2,
      name: 'StartupTN TANFUND',
      description:
        'Funding portal simplifying startup grant and application processes.',
      image: '/images/tanfund-first.png',
      color: '#8b5cf6',
      gradient: 'linear-gradient(135deg, #8b5cf6 0%, #a855f7 100%)',
      navigate: '/works/tanfund'
    },
    {
      id: 3,
      name: 'OneTN',
      description:
        'Facilitate support services, driving inclusive growth for startups through collaboration.',
      image: '/images/onetn-first.png',
      color: '#f59e0b',
      gradient: 'linear-gradient(135deg, #f59e0b 0%, #f97316 100%)',
      navigate: '/works/onetn'
    },
    {
      id: 4,
      name: 'Open Innovation',
      description:
        'Innovation platform open to students, startups, and industries to collaborate.',
      image: '/images/openinnovation-first.png',
      color: '#10b981',
      gradient: 'linear-gradient(135deg, #10b981 0%, #0d9488 100%)',
      navigate: '/works/openinnovation'
    },
    {
      id: 5,
      name: 'StartupTN Catalyst',
      description:
        'Startup management system connecting innovators and investors.',
      image: '/images/catalyst-first.png',
      color: '#ef4444',
      gradient: 'linear-gradient(135deg, #ef4444 0%, #ec4899 100%)',
      navigate: '/works/catalyst'
    }
    // {
    //   id: 6,
    //   name: 'PAARR ever',
    //   description: 'Smart e-commerce and retail management platform.',
    //   image: '/images/paar-first.png',
    //   color: '#6366f1',
    //   gradient: 'linear-gradient(135deg, #6366f1 0%, #3b82f6 100%)',
    //   navigate: '/project/paarrever'
    // }
  ];

  return (
    <Box component="section" sx={styles.section} id="portfolio">
      <Box sx={styles.backgroundContainer}>
        <Box sx={styles.gradientBase} />
        <Box sx={styles.meshGradient} />
        <motion.div
          style={{
            ...styles.floatingShape1
          }}
          animate={{
            x: mousePosition.x * 50,
            y: mousePosition.y * 50 - scrollY * 0.3,
            rotate: scrollY * 0.15
          }}
          transition={{ type: 'spring', stiffness: 100, damping: 30 }}
        />
        <motion.div
          style={{
            ...styles.floatingShape2
          }}
          animate={{
            x: mousePosition.x * -40,
            y: mousePosition.y * -40 - scrollY * 0.25,
            rotate: -scrollY * 0.1
          }}
          transition={{ type: 'spring', stiffness: 100, damping: 30 }}
        />
        <motion.div
          style={{
            ...styles.floatingShape3
          }}
          animate={{
            x: mousePosition.x * 35,
            y: mousePosition.y * 35 - scrollY * 0.2,
            rotate: scrollY * 0.12
          }}
          transition={{ type: 'spring', stiffness: 100, damping: 30 }}
        />
        <motion.div
          style={{
            ...styles.glowOrb1
          }}
          animate={{
            x: mousePosition.x * 60,
            y: mousePosition.y * 60 - scrollY * 0.4
          }}
        />
        <motion.div
          style={{
            ...styles.glowOrb2
          }}
          animate={{
            x: mousePosition.x * -50,
            y: mousePosition.y * -50 - scrollY * 0.35
          }}
        />
        <motion.div
          style={{
            ...styles.glowOrb3
          }}
          animate={{
            x: mousePosition.x * 45,
            y: mousePosition.y * 45 - scrollY * 0.3
          }}
        />
        {[...Array(15)].map((_, i) => (
          <Box
            key={i}
            sx={{
              ...styles.particle,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${10 + Math.random() * 15}s`
            }}
          />
        ))}
        <motion.div
          style={{
            ...styles.lightBeam1
          }}
          animate={{
            x: mousePosition.x * 70,
            y: mousePosition.y * 70
          }}
        />
        <motion.div
          style={{
            ...styles.lightBeam2
          }}
          animate={{
            x: mousePosition.x * -60,
            y: mousePosition.y * -60
          }}
        />
      </Box>
      <Container maxWidth="xl" sx={styles.container}>
        <Box sx={styles.header}>
          <Box sx={styles.headerBadge}>
            <span style={styles.badgeIcon}>🎨</span>
            <Typography sx={styles.badgeText}>Featured Work</Typography>
          </Box>
          <Typography sx={styles.subtitle}>
            Discover our collection of projects that push boundaries and deliver
            exceptional results
          </Typography>
        </Box>
        <Grid container spacing={4} justifyContent="center">
          {portfolioItems.map((project, index) => (
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              key={project.id}
              sx={styles.gridItem}
            >
              <motion.div
                initial={{ opacity: 0, y: 60 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.15 }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <Box sx={styles.projectCard}>
                  <Box
                    sx={{
                      ...styles.cardGlow,
                      background: project.gradient,
                      opacity: hoveredIndex === index ? 0.4 : 0
                    }}
                  />
                  <Box sx={styles.imageWrapper}>
                    <motion.img
                      src={project.image}
                      alt={project.name}
                      style={styles.projectImage}
                      // animate={{
                      //   scale: hoveredIndex === index ? 1.1 : 1
                      // }}
                      transition={{ duration: 0.7 }}
                    />
                    <Box
                      sx={{
                        ...styles.imageOverlay,
                        opacity: hoveredIndex === index ? 1 : 0
                      }}
                    />
                  </Box>
                  <motion.div
                    style={styles.contentOverlay}
                    animate={{
                      y: hoveredIndex === index ? 0 : 20,
                      opacity: hoveredIndex === index ? 1 : 0
                    }}
                    transition={{ duration: 0.1 }}
                  >
                    <Box sx={styles.projectInfo}>
                      <Typography sx={styles.projectName}>
                        {project.name}
                      </Typography>
                      <Typography sx={styles.projectDescription}>
                        {project.description}
                      </Typography>
                      <Button
                        component="button"
                        sx={{
                          ...styles.visitButton,
                          background: project.gradient
                        }}
                        onClick={() => navigate(project.navigate)}
                      >
                        <span style={styles.buttonText}>Know More</span>
                        <motion.span
                          style={styles.buttonIcon}
                          animate={{ x: hoveredIndex === index ? 5 : 0 }}
                        >
                          →
                        </motion.span>
                      </Button>
                    </Box>
                  </motion.div>
                  <Box
                    sx={{
                      ...styles.cornerDecoration,
                      borderTopColor:
                        hoveredIndex === index ? project.color : 'transparent',
                      borderLeftColor:
                        hoveredIndex === index ? project.color : 'transparent'
                    }}
                  />
                  <Box
                    sx={{
                      ...styles.cornerDecorationBottom,
                      borderBottomColor:
                        hoveredIndex === index ? project.color : 'transparent',
                      borderRightColor:
                        hoveredIndex === index ? project.color : 'transparent'
                    }}
                  />
                  <Box
                    sx={{
                      ...styles.animatedBorder,
                      borderColor:
                        hoveredIndex === index
                          ? project.color
                          : 'rgba(255, 255, 255, 0.1)'
                    }}
                  />
                  {hoveredIndex === index && (
                    <>
                      <Box sx={{ ...styles.sparkle, ...styles.sparkle1 }} />
                      <Box sx={{ ...styles.sparkle, ...styles.sparkle2 }} />
                      <Box sx={{ ...styles.sparkle, ...styles.sparkle3 }} />
                    </>
                  )}
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default OurProjectsClients;
